import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class ClientModel {
    clientId() {
        return this.dto.clientId;
    }
    name() {
        return this.dto.name;
    }
    clientType() {
        return this.dto.clientType;
    }
    isSample() {
        return this.dto.isSample;
    }
    status() {
        return this.dto.status;
    }
    owner() {
        return this.dto.owner;
    }
    contactsCount() {
        return this.dto.contactsCount;
    }
    archiveEligibility() {
        var _this_dto_archiveEligibility;
        return (_this_dto_archiveEligibility = this.dto.archiveEligibility) !== null && _this_dto_archiveEligibility !== void 0 ? _this_dto_archiveEligibility : {
            type: 'eligible'
        };
    }
    deleteEligibility() {
        var _this_dto_deleteEligibility;
        return (_this_dto_deleteEligibility = this.dto.deleteEligibility) !== null && _this_dto_deleteEligibility !== void 0 ? _this_dto_deleteEligibility : {
            type: 'eligible'
        };
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
